import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import icon from '../../common/icon';
export default class CollapseToggle extends Component {
  view() {
    const collapsed = Boolean(this.attrs.collapsed);
    const key = collapsed ? 'expand' : 'collapse';
    return m('button.NestedRepliesCollapseToggle.Button.Button--icon', {
      type: 'button',
      title: app.translator.trans(`mtareq-nested-replies.forum.${key}`),
      onclick: this.attrs.onclick
    }, icon(collapsed ? 'fas fa-plus' : 'fas fa-minus'));
  }
}
flarum.reg.add('mtareq-nested-replies', 'forum/components/CollapseToggle', CollapseToggle);